import { DashRegistrationStep } from '@/types/dashboard';

export interface IHistoryProgressModel {
    id: number;
    editKey: string;
    isIE: boolean;

    previousRegistrationStep: DashRegistrationStep | null;
    currentRegistrationStep: DashRegistrationStep;
    isQuickStartDonor: boolean;
    hasRequestedMenor: boolean;
    hasMultipleLanguages: boolean;

    isHistoryDemographicsComplete: boolean;
    isHistoryDiagnosedComplete: boolean;
    isHistoryFamilyComplete: boolean;
    isHistoryMiscComplete: boolean;
    isHistorySocialComplete: boolean;
    isHistorySummaryComplete: boolean;

    languageData: Record<string, string>;

    isFemale: boolean;
    isLiver: boolean;
}

export const defaultHistoryProgress: IHistoryProgressModel = {
    id: 0,
    editKey: '',
    isIE: false,
    previousRegistrationStep: null,
    currentRegistrationStep: DashRegistrationStep.HistoryDemographics,
    isQuickStartDonor: false,
    hasRequestedMenor: false,
    hasMultipleLanguages: false,

    isHistoryDemographicsComplete: false,
    isHistoryDiagnosedComplete: false,
    isHistoryFamilyComplete: false,
    isHistoryMiscComplete: false,
    isHistorySocialComplete: false,
    isHistorySummaryComplete: false,

    languageData: {},

    isFemale: false,
    isLiver: false
};
